// Angular
import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AlertNoticeService } from "../../../../core/alert/alert.service";
// Auth
import { AuthService } from "../../../../core/services/auth.service";
import { listTermsComponent } from "../terms-dialog/list-terms.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "kt-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit {
  public codeBus = new EventEmitter<string>();

  // Public params
  loginForm: FormGroup;
  loading = false;
  disableButton: boolean = true;
  disableMess: boolean = false;
  showAlert = false;
  stepTwo = false;
  hide = true;
  sizeCode = 4;
  errorCode = false;
  code: string[];
  successCode = false;
  loadingCode = false;
  showResend: boolean = false;
  myIp: string = "";
  newCode: boolean = false;
  newCodeMess: boolean = false;

  constructor(private router: Router, private auth: AuthService, private fb: FormBuilder, private cdr: ChangeDetectorRef, private authNoticeService: AlertNoticeService, public dialog: MatDialog) {}

  /**
   * On init
   */
  ngOnInit(): void {
    this.initLoginForm();
    this.handlePasteEvent();
    this.getMyIp();
  }

  getMyIp() {
    this.auth.getMyIp().then(
      (_res) => {
        this.myIp = _res?.ip || "";
      },
      (_err) => {
        console.log(_err);
      }
    );
  }

  OnDestroy() {
    window.removeEventListener("paste", this.handleVerificationCode.bind(this));
  }

  /**
   * Form initalization
   * Default params, validators
   */
  initLoginForm() {
    this.loginForm = this.fb.group({
      email: ["", Validators.compose([Validators.required, Validators.email])],
      password: ["", Validators.required],
      recaptcha: ["", Validators.required],
    });
  }

  onRecaptchaSuccess(token: string) {
    if (token) {
      this.disableMess = false;
      this.disableButton = false;
      this.loginForm.get("recaptcha")?.setValue(token);
    }
  }

  onRecaptchaError(err?: any) {
    console.log("Recaptcha error:", err);
  }

  resetRecaptcha(res?: any) {
    this.loginForm.get("recaptcha")?.setValue("");
    console.log("Recaptcha expired!");
  }

  /**
   * Form Submit
   */
  submit(form: any) {
    if (this.disableButton) {
      this.disableMess = true;
      return;
    }
    this.showAlert = false;
    this.disableButton = true;
    this.loading = true;
    /** check form */
    if (form.valid) {
      setTimeout(() => {
        this.newCode = true;
        this.cdr.markForCheck();
      }, 10000);
      const { email, password, recaptcha } = form.value;
      const authData = {
        username: email,
        password: password,
        recaptchaResponse: recaptcha,
        ipAddress: this.myIp,
        code: this.code?.join?.("") || null,
      };
      this.auth.login(authData).then(
        (_res) => {
          if (_res?.message === "OTP_REQUIRED") {
            this.loading = false;
            this.disableButton = false;
            this.stepTwo = true;
            this.loginForm.get("recaptcha")?.setValue("");
            this.cdr.markForCheck();
          } else {
            this.successCode = true;
            this.errorCode = false;
            if (_res.token) this.auth.setAccessToken(_res.token);
            this.auth.profile().subscribe((res) => {
              this.disableButton = false;
              this.loading = false;
              this.router.navigateByUrl("/");
              this.cdr.markForCheck();
            });
          }
        },
        (_err) => {
          this.loading = false;
          this.successCode = false;
          this.errorCode = true;
          this.authNoticeService.setNotice(this.stepTwo ? _err.error.error : "Usuario no autorizado", "danger");
          this.showAlert = true;
          this.disableButton = false;
          this.newCode = true;
          this.newCodeMess = false;
          if (_err.error.error.includes("APTCHA") || _err.error.error.includes("aptcha")) {
            this.loginForm.get("recaptcha")?.setValue("");
            this.newCode = true;
            this.newCodeMess = false;
          }
          this.cdr.markForCheck();
        }
      );
    } else {
      if (this.stepTwo) {
        this.disableMess = true;
        this.loading = false;
      } else {
        this.loading = false;
        this.authNoticeService.setNotice("Ingrese un correo y contraseña válidos", "danger");
        this.showAlert = true;
        Object.keys(form.controls).forEach((controlName) => form.controls[controlName].markAsTouched());
        this.cdr.markForCheck();
      }
    }
  }

  newOTP(form: any) {
    const { email } = form.value;
    const body = {
      email: email,
      ipAddress: this.myIp,
    };

    this.auth.newOTP(body).then(
      (_res) => {
        this.newCode = false;
        this.newCodeMess = true;
        this.disableMess = false;
        this.cdr.markForCheck();
      },
      (_err) => {
        this.loading = false;
        this.successCode = false;
        this.errorCode = true;
        this.authNoticeService.setNotice(this.stepTwo ? _err.error.error : "Usuario no autorizado", "danger");
        this.showAlert = true;
        this.disableButton = false;
        this.cdr.markForCheck();
      }
    );
  }

  handleCode(code: any) {
    let rCode = code.filter(Boolean);
    if (rCode.length === this.sizeCode) {
      this.successCode = true;
      this.code = code;
    }
  }

  resetCode() {
    this.loadingCode = false;
    this.successCode = false;
    this.errorCode = false;
  }

  /**
   * Checking control validation
   *
   * @param controlName: string => Equals to formControlName
   * @param validationType: string => Equals to valitors name
   */
  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.loginForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  openDialog(): void {
    this.dialog.open(listTermsComponent);
  }

  //subscripcion al evento paste del windows
  private handlePasteEvent() {
    window.addEventListener("paste", this.handleVerificationCode.bind(this));
  }

  //cuando el usuario pegue el código de verificación
  private handleVerificationCode(e: ClipboardEvent) {
    const pastedText = e.clipboardData?.getData("text") || "";
    if (pastedText.length === this.sizeCode) {
      this.codeBus.emit(pastedText);
    }
  }
}
